import React, { useContext } from "react";

export const UserContext = React.createContext();

export const isAdministrator = (user) => {
  return !!(user && (user.role === 'administrator' || user.role === 'apasi_portal_admin'));
};

export const useCurrentUser = () => {
  const user = useContext(UserContext);
  return user;
}

export const useIsAdministrator = () => {
  const user = useCurrentUser();
  return isAdministrator(user);
}
